import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateCustomerStatus } from "../../api/apiCustomers";
import parseError from "../../utils/parseError";

export const useUpdateCustomerStatus = () => {
    const queryClient = useQueryClient();

    const { mutate: updateCustomerStatusMutate, isPending: isUpdatingStatus } = useMutation({
        mutationFn: ({ id, data }) => updateCustomerStatus(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Customer status updated");
            queryClient.invalidateQueries(["customers"]);
            queryClient.invalidateQueries(["customer"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update status");
        },
    });

    return { updateCustomerStatusMutate, isUpdatingStatus };
};
